import JSEncrypt from "jsencrypt";

var encrypt = new JSEncrypt();

encrypt.setPublicKey(
    "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCtvTfVNzld42fmdAtgmMNPFYOgbq2Y1UmHv0NysJaTbRye3FRjETY5uyiXnZPKBwFCHD1B99AgKDNVfYKTZbV3wNfOheV33hzN6HGPMh4mLQ5B6qtaAahIcAp/IcL5DdHtfk/fWrGAl1GO57zCSHPPowph+aV3uHP5VHpk2TrJCQIDAQAB-----END PUBLIC KEY-----"
);

export default encrypt;